import React from 'react';
import { useTranslation } from 'react-i18next';

const TenantConfigurationError = () => {
  const { t } = useTranslation('common');

  return (
    <main className="min-h-screen bg-neutral-100 p-6 flex items-center justify-center">
      <section className="w-full max-w-lg rounded-3xl border border-neutral-200 bg-white p-8 text-center shadow-xl">
        <h1 className="text-2xl font-bold text-neutral-800">
          {t('tenantConfiguration.title')}
        </h1>
        <p className="mt-3 text-neutral-600">
          {t('tenantConfiguration.description')}
        </p>
      </section>
    </main>
  );
};

export default TenantConfigurationError;
